// extracted by mini-css-extract-plugin
export default {"about":"AboutSection_about__zzOVB","about-content":"AboutSection_about-content__IrI6B","about-light":"AboutSection_about-light__e6XV7","about-dark":"AboutSection_about-dark__7-yaU"};